import { AllSystemTypes, SystemTypes } from './system-types.enum';

export enum AsEntityTypes {
    TASK = 1,
    TM_TEST,
    TM_TEST_STEP,
    TM_DEFECT,
    TM_NOTE,
    TM_REQUIREMENT,
    TM_APPROVAL_REQUIREMENT_STEP,
    AS_RELEASE,
    TM_CYCLE,
    TEST_EXECUTION,
    TM_FEATURE = 12,
    TM_TASK,
    CQ_FEATURE,
    CQ_TASK,
    SCRIPT_STEP,
    SCRIPT_SECTION,
    TM_ITERATION,
    TM_TEST_DATA,
    AS_PROJECT,
    ANALYSIS,
    SCOPE,
    TM_FOLDER,
    TM_BUSINESS_PROCESS,
    TM_CORRECTION_ACTIVITY,
    IMPACTED_ENTRY_POINT,
    SAP_OBJECT,
    PA_TEST_SET,
    PA_EXECUTION,
    PA_EXECUTION_SCHEDULING,
    TM_CHANGE,
    PA_RUN
}

export enum AsEntityTypeNames {
    CORRECTION = 'Correction',
    TEST = 'Test',
    QUICK_TEST = 'Quick Test',
    STEP_PLANNED_RUN = 'Step / Planned Run',
    DEFECT = 'Defect',
    REQUIREMENT = 'Requirement',
    CODE_CHANGE = 'Change',
    FEATURE = 'Feature',
    TASK = 'Task',
    CHANGE = 'Change',
    AUTOMATED_TEST = 'External Test',
    SAP_OBJECT = 'Sap Object',
    STEP = 'TestStep',
    SCRIPT = 'Script',
    ANALYSIS = 'Analysis',
    PA_TEST_SET = 'Test Set',
    PA_EXECUTION = 'Execution',
    PA_EXECUTION_SCHEDULING = 'Execution Schedule'
}

export const entityTypeNameById = new Map<AsEntityTypes, AsEntityTypeNames>([
    [AsEntityTypes.TM_REQUIREMENT, AsEntityTypeNames.REQUIREMENT],
    [AsEntityTypes.TM_FEATURE, AsEntityTypeNames.FEATURE],
    [AsEntityTypes.TM_TASK, AsEntityTypeNames.TASK],
    [AsEntityTypes.TM_DEFECT, AsEntityTypeNames.DEFECT],
    [AsEntityTypes.TM_TEST, AsEntityTypeNames.TEST],
    [AsEntityTypes.TASK, AsEntityTypeNames.CORRECTION],
    [AsEntityTypes.ANALYSIS, AsEntityTypeNames.ANALYSIS],
    [AsEntityTypes.PA_TEST_SET, AsEntityTypeNames.PA_TEST_SET],
    [AsEntityTypes.PA_EXECUTION, AsEntityTypeNames.PA_EXECUTION],
    [AsEntityTypes.PA_EXECUTION_SCHEDULING, AsEntityTypeNames.PA_EXECUTION_SCHEDULING]
]);

export const ENTITY_TYPES: { [key: string]: EntityTypeData } = {
    CORRECTION: {
        id: AsEntityTypes.TASK,
        label: 'correction',
        serverEnum: 'TASK',
        serverValue: 'Correction',
        systemTypeSupport: AllSystemTypes
    },
    TEST: {
        id: AsEntityTypes.TM_TEST,
        label: 'test',
        serverEnum: 'TM_TEST',
        serverValue: 'Test',
        systemTypeSupport: AllSystemTypes
    },
    STEP: {
        id: AsEntityTypes.TM_TEST_STEP,
        label: 'stepPlannedRun',
        serverEnum: 'TM_TEST_STEP',
        serverValue: 'Step / Planned Run',
        systemTypeSupport: AllSystemTypes
    },
    DEFECT: {
        id: AsEntityTypes.TM_DEFECT,
        label: 'defect',
        serverEnum: 'TM_DEFECT',
        serverValue: 'Defect',
        systemTypeSupport: AllSystemTypes
    },
    REQUIREMENT: {
        id: AsEntityTypes.TM_REQUIREMENT,
        label: 'requirement',
        serverEnum: 'TM_REQUIREMENT',
        serverValue: 'Requirement',
        orderId: 2,
        systemTypeSupport: AllSystemTypes
    },
    FEATURE: {
        id: AsEntityTypes.TM_FEATURE,
        label: 'feature',
        serverEnum: 'TM_FEATURE',
        serverValue: 'Feature',
        orderId: 4,
        systemTypeSupport: AllSystemTypes
    },
    TRANSPORT: {
        id: AsEntityTypes.TM_CHANGE,
        label: 'transport',
        serverEnum: 'TM_CHANGE',
        serverValue: 'Transport',
        systemTypeSupport: [SystemTypes.SAP]
    },
    TM_TASK: {
        id: AsEntityTypes.TM_TASK,
        label: 'task',
        serverEnum: 'TM_TASK',
        serverValue: 'Task',
        orderId: 6,
        systemTypeSupport: AllSystemTypes
    },
    ANALYSIS: {
        id: AsEntityTypes.ANALYSIS,
        label: 'Analysis',
        serverEnum: 'ANALYSIS',
        serverValue: 'Analysis',
        orderId: 1,
        systemTypeSupport: [SystemTypes.SALESFORCE]
    }
};

export interface EntityTypeData {
    id: AsEntityTypes;
    label: string;
    serverEnum: string;
    serverValue: string;
    orderId?: number;
    systemTypeSupport: SystemTypes[];
}
